module.exports = __webpack_public_path__ + "img/box_bottom.ff7e8495.jpg";